import api from './api';

/**
 * Servicio para gestionar categorías
 */
export const categoriasService = {
  /**
   * Obtener todas las categorías
   * @param {number} empresaId - ID de la empresa para filtrar (opcional)
   * @param {number} sucursalId - ID de la sucursal para filtrar (opcional)
   */
  getAll: async (empresaId = null, sucursalId = null) => {
    const params = {};
    if (empresaId) params.empresaId = empresaId;
    if (sucursalId) params.sucursalId = sucursalId;
    const response = await api.get('/categorias', { params });
    return response;
  },

  /**
   * Obtener una categoría por ID
   */
  getById: async (id) => {
    const response = await api.get(`/categorias/${id}`);
    return response;
  },

  /**
   * Crear una nueva categoría
   */
  create: async (categoria) => {
    const response = await api.post('/categorias', categoria);
    return response;
  },

  /**
   * Actualizar una categoría
   */
  update: async (id, categoria) => {
    const response = await api.put(`/categorias/${id}`, categoria);
    return response;
  },

  /**
   * Desactivar una categoría (baja lógica)
   */
  delete: async (id) => {
    const response = await api.delete(`/categorias/${id}`);
    return response;
  },
};

